<template>
  <div
    class="image-modal-wrapper position-fixed align-items-center justify-content-center d-flex">
    <div class="modal-inner align-items-center justify-content-center d-flex h-100 w-100">
      <div
        class="bm-image-modal-content im-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Add Audio">
        <div class="im-header">
          <h2 class="modal-heading">Add Audio</h2>
          <button
            type="button"
            class="im-close"
            aria-label="Close"
            title="Close"
            @click="closeModal">
            <icon name="close-icon"/>
          </button>
        </div>
        <div class="bm-modal-body border-0">
          <div class="tabs-wrapper">
            <div class="tabs-inner">
              <ul class="list-unstyled im-tabs mb-0">
                <li>
                  <tab
                    :id="2"
                    :tab-active="selectedId"
                    title="My computer"
                    @click="selectedId = '2'"/>
                </li>
                <li>
                  <tab
                    :id="1"
                    :tab-active="selectedId"
                    title="My gallery"
                    @click="selectedId = '1'"/>
                </li>
              </ul>
            </div>

            <div class="main-tabs-content">
              <div
                v-if="selectedId == 1"
                class="audio-gallery-pane">
                <gallery-audio/>
              </div>
              <div
                v-show="selectedId == 2"
                class="file-select">
                <audio-file-select/>
              </div>
              <div v-if="selectedId == 3">
                <stock-audio-box/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100"
      @click="closeModal"/>
  </div>
</template>

<script>
import Tab from '@/components/Tab/Tab';
import AudioFileSelect from '@/components/AudioFileSelect/AudioFileSelect';
import EventBus from '@/EventBus';
import StockAudioBox from '@/components/StockAudio/StockAudioBox';
import GalleryAudio from '../AudioGallery/GalleryAudio.vue';

export default {
  name:       'AudioModal',
  components: {
    tab:                 Tab,
    'audio-file-select': AudioFileSelect,
    'stock-audio-box':   StockAudioBox,
    'gallery-audio':     GalleryAudio,
  },
  data() {
    return {
      selectedId: '2',
    };
  },
  mounted() {
    EventBus.$on('toggleTabs', this.handleTabClick);
  },
  beforeDestroy() {
    EventBus.$off('toggleTabs', this.handleTabClick);
  },
  methods: {
    handleTabClick(id) {
      this.selectedId = id;
    },
    closeModal() {
      EventBus.$emit('abortAudioUpload');
      this.$store.commit('setDisplayAddAudioModal', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-gallery-pane {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  overflow: hidden !important;
}
</style>
